export default __webpack_public_path__ + "static/media/ami.f1b09491.jpg";